import { useTranslations } from '@npco/utils-translations'
import { Label } from '@npco/zeller-design-system'

import { currencyFormatter } from 'utils/common'
import { useZellerTransferValues } from 'pages/Transfer/states/TransferSummary/TransferSummary.hooks'
import {
  StyledTransferAmount as Amount,
  StyledTransferDetails as Details,
  StyledTransferSummaryRow as SummaryRow,
  StyledTransferValue as Value,
} from 'pages/Transfer/states/TransferSummary/TransferSummary.styled'
import { zellerTransferTranslations } from 'pages/Transfer/Transfer.i18n'

export const TransferSummary = () => {
  const { formValues } = useZellerTransferValues()
  const t = useTranslations(zellerTransferTranslations)

  return (
    <div data-testid="transfer-summary">
      <Details>
        <SummaryRow>
          <Label>{t('amountLabel')}</Label>
          <Amount>{currencyFormatter(+formValues.amount * 100)}</Amount>
        </SummaryRow>

        <SummaryRow>
          <Label>{t('referenceSummary')}</Label>
          <Value>{formValues.reference}</Value>
        </SummaryRow>
      </Details>
    </div>
  )
}
